export enum PortalRole {
  ADMIN_CAPTURER = 'ADMIN_CAPTURER',
  ADMIN_SUPERVISOR = 'ADMIN_SUPERVISOR',
  ADMIN_MANAGER = 'ADMIN_MANAGER',
}

export const WRITE_ROLES: readonly string[] = [];
